import React, { useState, useEffect } from 'react';
import { Table, Card, Button } from "reactstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import api, { FILE_BASE_URL } from '../../utils/api';
const LatestActivists = () => {
    const [activists, setActivists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [failedImages, setFailedImages] = useState(new Set());

    const formatDate = (dateString) => {
        if (!dateString) return 'غير محدد';
        
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    // دالة لإنشاء الدائرة الملونة
    const getAvatarCircle = (name) => {
        const firstLetter = name ? name.charAt(0).toUpperCase() : 'ن';
        
        return (
            <div 
                className="avatar-xs me-2 rounded-circle d-inline-flex align-items-center justify-content-center"
                style={{
                    backgroundColor: '#f46a6a', // أحمر للناشطين
                    color: '#ffffff',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    width: '30px',
                    height: '30px'
                }}
            >
                {firstLetter}
            </div>
        );
    };

    // دالة للحصول على الأفاتار (صورة أو دائرة)
    const getProfileAvatar = (activist, index) => {
        const imageKey = `activist-${activist.id}-${index}`;
        
        // إذا فشلت الصورة مسبقاً، اعرض الدائرة مباشرة
        if (!activist.profile_image || failedImages.has(imageKey)) {
            return getAvatarCircle(activist.full_name);
        }

        // تحديد مسار الصورة الصحيح
        let imageSrc = '';
        if (activist.profile_image.startsWith('http')) {
            imageSrc = activist.profile_image;
        } else {
            imageSrc = `${FILE_BASE_URL}/uploads/images/${activist.profile_image}`;
        }

        return (
            <img 
                src={imageSrc} 
                alt="user" 
                className="avatar-xs me-2 rounded-circle"
                onError={() => {
                    // أضف الصورة لقائمة الفاشلة
                    setFailedImages(prev => new Set([...prev, imageKey]));
                }}
            />
        );
    };

    const fetchActivists = async () => {
        try {
           setLoading(true);
           const response = await api.get("/activists");
           const data = response.data.data || response.data || [];
            
            // أخذ آخر 6 ناشطين
            setActivists(data.slice(0, 6));
        } catch (error) {
            console.error("خطأ في جلب الناشطين:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchActivists();
    }, []);

    if (loading) {
        return (
            <Card>
                <div className="card-body">
                    <h4 className="card-title mb-4">آخر الناشطين</h4>
                    <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">جاري التحميل...</span>
                        </div>
                    </div>
                </div>
            </Card>
        );
    }

    return (
        <Card>
            <div className="card-body">
                <h4 className="card-title mb-4">آخر الناشطين</h4>

                <div className="table-responsive">
                    <Table className="align-middle table-centered table-vertical table-nowrap mb-1">
                        <tbody>
                            {activists.length === 0 ? (
                                <tr>
                                    <td colSpan="3" className="text-center py-4 text-muted">
                                        لا توجد بيانات لعرضها
                                    </td>
                                </tr>
                            ) : (
                                activists.map((activist, key) => (
                                    <tr key={key}>
                                        <td>
                                            {getProfileAvatar(activist, key)}
                                            {activist.full_name || 'غير محدد'}
                                        </td>
                                        <td>
                                            {formatDate(activist.created_at)}
                                        </td>
                                        <td>
                                            <Link to={`/dashboard/activists/edit/${activist.id}`}>
                                                <Button 
                                                    color="secondary" 
                                                    size="sm" 
                                                    className="waves-effect waves-light"
                                                >
                                                    تعديل
                                                </Button>
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </Card>
    );
};

export default LatestActivists;